<template>
  <div style="margin-top: 20px">
    <Table
      :data="tableData"
      :columns="columns"
      stripe
      ref="table"
      :height="370"
      style="width: 100%"
      no-data-text="<div class='table-no-data'></div>"
    >
      <template slot-scope="{ row, index }" slot="list">
        <div>
          <Tag
            v-for="(item, index) in row.alarmList"
            :key="index"
            :color="colors[item.alarmTypeName]"
            >{{ item.alarmTypeName }}：{{ item.num }}次</Tag
          >
        </div>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[50, 100, 200, 500, 1000]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
var store = [];
export default {
  data() {
    return {
      openTable: false,
      columns: [
        {
          type: "index",
          minWidth: 60,
          maxWidth: 100,
          align: "center",
        },
        {
          title: "日期",
          key: "date",
        },
        {
          title: "报警次数",
          slot: "list",
        },
      ],
      tableData: [],
      pageNumber: 1,
      pageSize: 500,
      total: 0,
      colors:{}
    };
  },
  methods: {
    reachData(data,colors) {
      store = data;
      this.colors=colors;
      this.total = data.length;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
    open() {
      this.openTable = true;
    },
    //页码切换时触发
    changePage(x) {
      this.pageNumber = x;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dataAnalyse/baojing/tableList.vue